import React, {useContext} from 'react';
import axios from "axios";
import {Button} from "reactstrap";
import authContext from "../../../AuthProvider/authContext";
import {handleError} from "../../HandleError";
import {BsCheckLg} from "react-icons/bs";
import localized from '../../../i18n';
import en from "../../../i18n/languages/en";
import {Card, Col} from "react-bootstrap";

const PlanCard = ({plan,index}) => {
    const {state} = useContext(authContext);
    const user = state.auth;
    const language = localized.getLanguage();

    const purchasePlan = (plan = null) => {
        window.location.href = plan.payment_url;
    }
    const data = localized.getLanguage() === "en" ? plan.description.split("|") :plan.description_fr.split("|");
    return (
            <Card className={`pricing-card ${plan.type===1 ? 'subscription-pricing' : 'addition-pricing'}`}>
                {(plan.type === 1 && !plan.payment_url) && (
                    <div className="current-plan">
                        <div className="main-current-plan">
                            {localized.current_plan}
                        </div>
                    </div>
                )}
                <Card.Body>
                    <div className='plan-peice'>
                        <div className={plan.type === 1 && "d-flex gap-1"}>
                            <h1>
                                {language === "fr"
                                    ? plan.price.replace("€", "").replace(".", ",")
                                    : plan.price.replace("€", "")
                                }
                                <span>€</span>
                            </h1>
                            {plan.type === 1 && (
                                <h1><span> / {localized.month}</span></h1>
                            )}
                            {plan.type === 2 && (
                                <p>{localized.on_time_credit}</p>
                            )}
                        </div>
                        {plan.type === 1 && (
                            <p>{localized.no_commitment}</p>
                        )}
                    </div>
                    <div className='pricing-btn'>
                        <button
                            className="primary-btn"
                            disabled={(user.plan && user.plan.id) === plan.id}
                            onClick={()=>purchasePlan(plan)}
                        >
                            <div className="buy-now cursor-pointer">
                                {plan.type===1 ? localized.subscribe : localized.buy_now}
                                {/*{(user.plan && user.plan.id) === plan.id ? localized.selected  : localized.buy_now}*/}
                            </div>
                        </button>
                    </div>
                    <ul className='pricing-menu'>
                        {(data || []).map((item,index)=>(
                            <li key={index}><BsCheckLg/>{item}</li>
                        ))}
                    </ul>
                </Card.Body>
            </Card>
    );
};

export default PlanCard;